import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { SoundfileCreate } from '@ragu-components/ord-types';

const SoundfileList = React.lazy(async () => import('./SoundfileList'));

export const soundfilesResource: OrdResourceProps = {
  key: Resources.soundfiles,
  name: Resources.soundfiles,
  list: <SoundfileList />,
  options: {},
  recordRepresentation: (soundfile: SoundfileCreate): string => soundfile.name,
};
